import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectActiveDestinations, selectFilterData } from '../../mainFilter/selectors'
import { t } from '../../../utilities/translator'
import { BESTOUTOF_HIGH_NUMBER } from '../../../constants/constants'

const isObject = (data) => {
  return typeof data === 'object' &&
  !Array.isArray(data) &&
  data !== null
}

const CardTitle = ({
  onClick,
  setCardTitle,
  hotel,
  destinations,
  dealDestination,
  bestOutOfDestination,
  noClick,
}) => {
  const { searchEngine: { what } } = useSelector(selectFilterData);
  const selectedDestinations = useSelector(selectActiveDestinations);
  const selectedThemes = what.filter(i => i.active);
  const [cardText, setCardText] = useState('');
  const {
    bestSellerHotelInTheme
  } = hotel;

  const cardDestinationClasses = selectedDestinations.length === 1
    ? 'label-small cursor-pointer pointer-events-none'
    : `label-small${noClick ? '' : ' underline cursor-pointer'} whitespace-nowrap`;

  const findHighestPositionedActiveTheme = () => {
    if (!isObject(bestSellerHotelInTheme)) {
      return null
    }

    let highestPositionedTheme = null;
    let highestPosition = 999;

    for (const themeId in bestSellerHotelInTheme) {
      const position = bestSellerHotelInTheme[themeId];
      if (selectedThemes.map(i => i.id).includes(Number(themeId)) && position < highestPosition) {
        highestPosition = position;
        highestPositionedTheme = themeId;
      }
    }

    return highestPositionedTheme;
  }

  const bestInTheme = findHighestPositionedActiveTheme();

  useEffect(() => {
    /* this was comment on request from Dror 20.02.2025
    if (bestOutOfDestination && bestOutOfDestination > 0) {
      const cardText = bestOutOfDestination >= BESTOUTOF_HIGH_NUMBER
        ? t('app.best_out_of_more_than_short')
        : t('dealItem.selected_out_of_short', {
            bestOutOfDestination: bestOutOfDestination.toLocaleString('en-US', { maximumFractionDigits: 2 }),
            name: dealDestination.name,
          });

      setCardTitle(cardText);
      setCardText(cardText);
    } */

    if (bestInTheme) {
      const position = hotel.bestSellerHotelInTheme[bestInTheme];
      const theme = selectedThemes.find(i => i.id === +bestInTheme);
      const cardText = t('dealItem.themeBestseller', { position, theme: theme.value });
      setCardTitle(cardText)
      setCardText(cardText);
    }

    if (isObject(hotel.bestSellerHotelInDestination)) {
      const position = Object.values(hotel.bestSellerHotelInDestination)[0];
      const cardText = t('dealItem.destinationBestseller', { position })
      setCardTitle(cardText);
      setCardText(cardText);
    }

    if (isObject(hotel.topTrendingHotelInDestination)) {
      const position = Object.values(hotel.topTrendingHotelInDestination)[0];
      const cardText = t('dealItem.destinationTrending', { position });
      setCardTitle(cardText);
      setCardText(cardText);
    }
  }, [bestInTheme, bestOutOfDestination, dealDestination.name, hotel.bestSellerHotelInDestination, hotel.bestSellerHotelInTheme, hotel.topTrendingHotelInDestination, selectedThemes, setCardTitle])

  if (bestOutOfDestination && bestOutOfDestination > 0) {
    return (
      <div className="caption-strong leading-4 mb-3 text-start flex items-center">
        <span className="truncate" dangerouslySetInnerHTML={{ __html: cardText }} />
        <span className={cardDestinationClasses} onClick={onClick}>{dealDestination.name}</span>
      </div>
    )
  }

  if (bestInTheme) {
    return (
      <div className="caption-strong leading-4 mb-3 text-start flex items-center">
        <span className="truncate" dangerouslySetInnerHTML={{ __html: cardText }} />
        <span className={cardDestinationClasses} onClick={onClick}>{dealDestination.name}</span>
      </div>
    )
  }

  if (isObject(hotel.bestSellerHotelInDestination)) {
    const destinationId = Object.keys(hotel.bestSellerHotelInDestination)[0];
    const destination = destinations.find(i => i.id === +destinationId);

    return (
      <div className="caption-strong leading-4 mb-3 text-start flex items-center">
        <span className="truncate" dangerouslySetInnerHTML={{ __html: cardText }} />
        <span className={cardDestinationClasses} onClick={onClick}>{destination?.name}</span>
      </div>
    )
  }

  if (isObject(hotel.topTrendingHotelInDestination)) {
    const destinationId = Object.keys(hotel.topTrendingHotelInDestination)[0];
    const destination = destinations.find(i => i.id === +destinationId);

    return (
      <div className="caption-strong leading-4 mb-3 text-start flex items-center">
        <span className="truncate" dangerouslySetInnerHTML={{ __html: cardText }} />
        <span className={cardDestinationClasses} onClick={onClick}>{destination?.name}</span>
      </div>
    )
  }

  return (
    <div className="caption-strong leading-4 mb-3 text-start flex items-center">
      <span className={cardDestinationClasses} onClick={onClick}>{dealDestination.name}</span>
    </div>
  )
}

export default CardTitle
